import { render, staticRenderFns } from "./MilionaireConsultationForm.vue?vue&type=template&id=7875edeb"
import script from "./MilionaireConsultationForm.vue?vue&type=script&lang=js"
export * from "./MilionaireConsultationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports